module.exports = __webpack_public_path__ + "static/media/suporte_icon.b8a4ac34.svg";